import BookingHistory from '../Components/TripManagement/BookingHistory';
import VendorBookingHistory from '../Components/TripManagement/VendorBookingHistory';
import TicketHistory from '../Components/Support/TicketHistory';
import Customers from '../Components/Customers';
import ChangePassword from '../Components/ChangePassword';
import BookingInfo from '../Components/TripManagement/BookingInfo';
import TripInfo from '../Components/TripManagement/TripInfo';
import CustomerProfile from '../Components/Customers/CustomerProfile';
import TimeLog from '../Components/TripManagement/TimeLog';
import DriverListing from '../Components/Driver/DriverListing';
import Help from '../Components/Help';
import DriverInfo from '../Components/Driver/DriverInfo';
import CaptureDashboard from '../Components/Dashboard/CaptureDashboard';
import VendorList from '../Components/Vendor/VendorList';
import DriverPayout from '../Components/Driver/DriverPayout';
import DriverDeductionApproval from '../Components/Driver/DriverDeductionApproval';
import CarListing from '../Components/Inventory/CarListing';
import CarTracking from "../Components/Inventory/CarTracking"
import Fleet from '../Components/Fleet';
import VendorProfile from '../Components/Vendor/VendorProfile';
import TripHistory from '../Components/TripManagement/TripHistory';
import VendorTripHistory from '../Components/TripManagement/VendorTripHistory';
import DispatchDashboard from '../Components/Dashboard/DispatchDashboard';
import MMTConfiguration from '../Components/MMTConfiguration';
import Packages from '../Components/Packages';
import Rates from '../Components/Rates';
import InvoiceCorrection from '../Components/InvoiceManagement/InvoiceCorrection';
import InvoiceList from '../Components/InvoiceManagement/InvoiceList';
import CorporateClient from '../Components/CorporateClient';
import Reports from '../Components/Reports';
import Employee from '../Components/Employee';
import Car from '../Components/Car';
import UnavailableCar from '../Components/Car/UnavailableCar';
import DriverRecharge from '../Components/Driver/DriverRecharge';
import CarInfo from '../Components/Car/CarInfo';
import OtpListing from '../Components/Users/OtpListing';
import Coupons from '../Components/Coupons';
import PackageRates from '../Components/PackageRates';
import Zone from '../Components/Zone';
import CorprateForms from '../Components/FormsTariff/CorprateForms';
import CorprateClientFlow from '../Components/CorprateClientsFlow/CorprateClientFlow';
import TariffModal from '../CommonElements/TariffModal/TariffModal';
import RentalFlow from '../Components/RentalFlow/RentalFlow';
import MeterFlow from '../Components/MeterFlow/MeterFlow';
import ThirdPartyFlow from '../Components/ThirdPartyFlow/ThirdPartyFlow';
import TariffMaster from '../Components/CreateTariff/TariffMaster';
import Tabs from '../Components/ViewTariff/Components/Tabs';
import ViewTariff from '../Components/ViewTariff/ViewTariff';

import CorpClientInfo from '../Components/ViewTariff/Components/CorpInfo/CorpClientInfo'
import PackInfo from '../Components/ViewTariff/Components/PackInfo/PackInfo';
import ServiceCityFlow from '../Components/ServiceCIty/Flow/ServiceCItyFlow';
import DriverSchemeForm from '../Components/DriverSchemeDeduction/Forms/DriverSchemeForm';
import { DriverSchemeDeductionForm } from '../Components/DriverSchemeDeduction/Forms/DriverSchemeDeductionForm';
// import WalletMinBal from '../Components/WalletBalance/Forms/WalletMinBal';
// import { DriverDeductionForm } from '../Components/DriverSchemeDeduction/Forms/DriverDeductionForm';
import DriverSchemeDeductionFlow from '../Components/DriverSchemeDeduction/Flow/DriverSchemeDeductionFlow';
import CarTypeFlow from '../Components/CarType/Flow/CarTypeFlow'

import CarTypeView from '../Components/CarType/View/CarTypeView';
import DriverTypeTable from '../Components/DriverSchemeDeduction/View/DriverTypeTable';
import DriverSchemeDetailView from '../Components/DriverSchemeDeduction/View/DriverSchemeDetailView';
import ZoneCountTable from '../Components/Zone/ZoneCountTable';
import ExterenalPartyInfo from '../Components/ViewTariff/Components/ExternalInfo/ExterenalPartyInfo';
import ExternalUser from '../Components/ExternalUser';
import CarCurrentStatus from '../Components/Vendor/CarCurrentStatus/CarCurrentStatus';
import CorprateClientsList from "../Components/ViewTariff/Components/CorprateClientsList";
import PackagesList from "../Components/ViewTariff/Components/PackagesList";
import RatesListView from "../Components/ViewTariff/Components/RatesListView";
import ViewTariffLayout from "../Layout/ViewTarrifLayout";
import BulkEditForm from '../Components/PackageRates/BulkEditForm/BulkEditForm';
import Offer from '../Components/Offer';

export const routes = [
  {
    path: `${process.env.PUBLIC_URL}/${localStorage.getItem("Name")}`,
    Component: <VendorBookingHistory />,
  },

  {
    path: `${process.env.PUBLIC_URL}/vendor/booking-history`,
    Component: <VendorBookingHistory />,
  },

  {
    path: `${process.env.PUBLIC_URL}/vendor/trip-history`,
    Component: <VendorTripHistory />,
  },

  {
    path: `${process.env.PUBLIC_URL}/vendor/car-current-status`,
    Component: <CarCurrentStatus />,
  },

  { path: `${process.env.PUBLIC_URL}/dashboard/capture-dashboard`, Component: <CaptureDashboard /> },

  { path: `${process.env.PUBLIC_URL}/dashboard/dispatch-dashboard`, Component: <DispatchDashboard /> },

  { path: `${process.env.PUBLIC_URL}/booking/booking-history`, Component: <BookingHistory /> },

  { path: `${process.env.PUBLIC_URL}/booking/booking-info/:bookingId`, Component: <BookingInfo /> },

  { path: `${process.env.PUBLIC_URL}/trips/trip-info/:tripId`, Component: <TripInfo /> },

  { path: `${process.env.PUBLIC_URL}/support/ticket-history`, Component: <TicketHistory /> },

  { path: `${process.env.PUBLIC_URL}/customers`, Component: <Customers /> },

  { path: `${process.env.PUBLIC_URL}/profile/change-password`, Component: <ChangePassword /> },

  { path: `${process.env.PUBLIC_URL}/tariff_master/rates`, Component: <Rates /> },

  { path: `${process.env.PUBLIC_URL}/configurations/packages`, Component: <Packages /> },

  { path: `${process.env.PUBLIC_URL}/tariff_master/package-rates`, Component: <PackageRates /> },

  { path: `${process.env.PUBLIC_URL}/tariff_master/bulk-edit`, Component: <BulkEditForm /> },

  { path: `${process.env.PUBLIC_URL}/tariff_master/corporate-clients`, Component: <CorporateClient /> },

  { path: `${process.env.PUBLIC_URL}/customers/customer-profile/:customerId`, Component: <CustomerProfile /> },

  { path: `${process.env.PUBLIC_URL}/booking/booking-info/time-log/:bookingNumber`, Component: <TimeLog /> },

  { path: `${process.env.PUBLIC_URL}/driver/driver-listing`, Component: <DriverListing /> },
  { path: `${process.env.PUBLIC_URL}/driver/driver-payout`, Component: <DriverPayout /> },
  { path: `${process.env.PUBLIC_URL}/driver/deduction-approval`, Component: <DriverDeductionApproval /> },


  { path: `${process.env.PUBLIC_URL}/help`, Component: <Help /> },

  { path: `${process.env.PUBLIC_URL}/driver/driver-info/:driverId`, Component: <DriverInfo /> },

  { path: `${process.env.PUBLIC_URL}/vendor/vendor-list`, Component: <VendorList /> },

  { path: `${process.env.PUBLIC_URL}/inventory/cab-listing`, Component: <Car /> },

  { path: `${process.env.PUBLIC_URL}/inventory/blocked-cab-listing`, Component: <UnavailableCar /> },

  { path: `${process.env.PUBLIC_URL}/driver/cab/cab-listing`, Component: <CarListing /> },
  { path: `${process.env.PUBLIC_URL}/driver/cab/zone-listing`, Component: <ZoneCountTable/> },


  { path: `${process.env.PUBLIC_URL}/driver/cab/cab-tracking`, Component: <CarTracking /> },

  { path: `${process.env.PUBLIC_URL}/fleet`, Component: <Fleet /> },

  { path: `${process.env.PUBLIC_URL}/user/employee-listing`, Component: <Employee /> },

  { path: `${process.env.PUBLIC_URL}/vendor/vendor-profile/:vendor_name`, Component: <VendorProfile /> },

  { path: `${process.env.PUBLIC_URL}/trips/trip-history`, Component: <TripHistory /> },

  { path: `${process.env.PUBLIC_URL}/tariff_master/inventory-control`, Component: <MMTConfiguration /> },

  { path: `${process.env.PUBLIC_URL}/configurations/coupons`, Component: <Coupons /> },

  { path: `${process.env.PUBLIC_URL}/configurations/zone`, Component: <Zone /> },

  { path: `${process.env.PUBLIC_URL}/configurations/service-city`, Component:<ServiceCityFlow />},
  
  { path: `${process.env.PUBLIC_URL}/configurations/offer`, Component: <Offer /> },

  { path: `${process.env.PUBLIC_URL}/bookings/invoice-correction`, Component: <InvoiceCorrection /> },

  { path: `${process.env.PUBLIC_URL}/bookings/invoice-list`, Component: <InvoiceList /> },

  { path: `${process.env.PUBLIC_URL}/reports`, Component: <Reports /> },

  { path: `${process.env.PUBLIC_URL}/driver/driver-recharge`, Component: <DriverRecharge /> },

  { path: `${process.env.PUBLIC_URL}/car/car-info/:carId`, Component: <CarInfo /> },

  { path: `${process.env.PUBLIC_URL}/user/otp-listing`, Component: <OtpListing /> },
  { path: `${process.env.PUBLIC_URL}/user/external_user`, Component: <ExternalUser /> },

  // { path: `${process.env.PUBLIC_URL}/tariff_master/view`, Component:<ViewTariff/>},
  // { path: `${process.env.PUBLIC_URL}/user/corp/info/:corpId`, Component:<CorpClientInfo />},
  // { path: `${process.env.PUBLIC_URL}/user/ext/info/:extId`, Component:<ExterenalPartyInfo/>},
  {
    path: `${process.env.PUBLIC_URL}/tariff_master/view`,
    element: <ViewTariffLayout />,
    children: [
      { 
        path: "", 
        element: <CorprateClientsList />, // Default to first tab
        index: true 
      },
      { path: "corp", element: <CorprateClientsList /> },
      { path: "packages", element: <PackagesList /> },
      { path: "meter", element: <RatesListView /> },
      // Detail pages that should still show the same tab header:
      { path: "corp/info/:corpId", element: <CorpClientInfo /> },
      { path: "ext/info/:extId", element: <ExterenalPartyInfo /> },
      { path: "packages/:packId", element: <PackInfo /> },
    ],
  },

  {
    path: `${process.env.PUBLIC_URL}/user/pack/info/:packId`,
    Component: <PackInfo />,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/driver/deduction`,
    Component: <DriverSchemeDeductionFlow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/car/type`,
    Component: <CarTypeView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/driver/driverType`,
    Component: <DriverTypeTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/driver/driver-scheme-details/:id`,
    Component: <DriverSchemeDetailView />,
  },
];
